import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://19821f78fadaed11a561852f4004d84b@o4508495101689856.ingest.us.sentry.io/4508955580628992',
  integrations: [],
})
